import { Module } from 'vuex';
import { RootState } from '../store';
import { mutations } from '../mutations/document-settings.mutations';
import { actions } from '../actions/document-settings.actions';
import { IDocumentSettings } from '@/types/DocumentSettings';
import { ITheme } from '@/settings/types/theme';

export const namespace = 'documentSettings';

export interface IDocumentSettingsState {
  isLoading: boolean;
  settings: IDocumentSettings;
  theme: ITheme;
}

export const state: IDocumentSettingsState = {
  isLoading: false,
  settings: {
    allowDocumentDownload: false,
    allowSigningForward: false,
    requireSelfSign: false,
    verifySmsOpen: false,
    verifySmsSign: false,
    isSigningBiometric: false,
    isSigningInitials: false,
    isSigningLinkedIn: false,
    isSigningEId: false,
    isSigningWrite: false,
    hasDisabledComments: false,
    doIdentifyRecipient: false,
    hasEsignConsent: false,
    documentUniqueId: 0,
  },
  theme: {
    name: '',
    backgroundColor: '',
    backgroundImage: '',
    accentColor: '',
    signButtonText: '',
  },
};

const namespaced: boolean = true;

export const documentSettings: Module<IDocumentSettingsState, RootState> = {
  actions,
  mutations,
  namespaced,
  state,
};
